const requestMediaKeySystemAccess = (function () {
  if (window.navigator && window.navigator.requestMediaKeySystemAccess)
    return window.navigator.requestMediaKeySystemAccess.bind(window.navigator);
  else
    return null;
})();

export {
  requestMediaKeySystemAccess
};



// WEBPACK FOOTER //
// ./src/helper/mediakeys-helper.js